<template>

  <div id="app">
    <Menu ref="menuComponent"/>
    <Manejadores />
    <router-view/>
    <Footer />
    <cookieweb />
  </div>
</template>

<script>
import Home from '@/views/Home.vue'
import Menu from '@/components/Menu.vue'
import Manejadores from '@/components/menu-manejadores.vue'
import Footer from '@/components/Footer.vue'
import cookieweb from '@/components/cookieweb.vue'


export default {
  name:'app',
  components:{
    Home,
    Menu,
    Manejadores,
    Footer,
    cookieweb
  },
  data() {
    return {
    }
  },
  methods: {
    refixChat() {
      window.addEventListener('scroll', function(event){    
          var btn = document.getElementById('launcher');
          if(btn !=null && btn != undefined){
            var windowHeight = document.body.offsetHeight - window.innerHeight;
            var footerHeight = document.getElementById("footer").scrollHeight;
            //console.log(windowHeight);
            var position = window.scrollY;
            //console.log(position);
            
            var height = (windowHeight-footerHeight);
            //console.log(height);
            var margin = (position-height)+10;
            //console.log(margin);
            margin = margin + "px";

            if(position < height){
              btn.style.marginBottom="10px";
            }else{
              btn.style.marginBottom=margin;
            }
          }
        });
    },
    Init(){

    },
  },
  mounted () {
    this.refixChat();
  },
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 100px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/**Chat elemento */
.inbenta-launcher {
    position: fixed!important;
    right: 40px!important;
    bottom: 40px!important;
    display: -ms-flexbox;
    display: flex;
    -ms-justify-content: center;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
    background-color: #fff;
    padding: 15px;
    border-radius: 50px;
    border: 2px solid #1E2144;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    height: 60px;
    width: 60px;
    transition: all .2s ease-in 0s;
    z-index: 1024;
    cursor: pointer;
    animation: pop;
    animation-duration: .7s;
    background: #1E2144;
}
/**Chat fin elemento */
</style>
